<template>
  <div class="row">
    <div class="col titre">
      <h2>Recherche Suivi</h2>
    </div>
  </div>
  <div class="row">
    <div class="col-4">
      <div class="row pb5 ml5 recherche-suivi-radio-btns"> <!--Emis-->
        <div class="col">
          <div class="row">
            <div class="col left"><label>Tous :</label></div>
            <div class="col left">
              <RadioButton name="statutEmis" value="EMIS_PAR_TOUS" v-model="statutEmis"/>
            </div>
          </div>
          <div class="row">
            <div class="col left"><label>Émis par moi :</label></div>
            <div class="col left">
              <RadioButton name="statutEmis" value="EMIS_PAR_MOI" v-model="statutEmis"/>
            </div>
          </div>
          <div class="row">
            <div class="col left"><label>Émis pour moi :</label></div>
            <div class="col left">
              <RadioButton name="statutEmis" value="EMIS_POUR_MOI" v-model="statutEmis"/>
            </div>
          </div>
        </div>
      </div>
      <div class="row pb5 pt5 ml5 recherche-suivi-radio-btns"> <!--Approuvé-->
        <div class="col">
          <div class="row">
            <div class="col left"><label>Tous :</label></div>
            <div class="col left">
              <RadioButton name="statutApprobation" value="APPROUVE_TOUS" v-model="statutApprobation"/>
            </div>
          </div>
          <div class="row">
            <div class="col left"><label>Approuvé :</label></div>
            <div class="col left">
              <RadioButton name="statutApprobation" value="APPROUVE" v-model="statutApprobation"/>
            </div>
          </div>
          <div class="row">
            <div class="col left"><label>Non approuvé :</label></div>
            <div class="col left">
              <RadioButton name="statutApprobation" value="NON_APPROUVE" v-model="statutApprobation"/>
            </div>
          </div>
        </div>
      </div>
      <div class="row pb5 pt5 ml5 recherche-suivi-radio-btns"> <!--Complété-->
        <div class="col">
          <div class="row">
            <div class="col left"><label>Tous :</label></div>
            <div class="col left">
              <RadioButton name="statutCompletee" value="COMPLETE_TOUS" v-model="statutCompletee"/>
            </div>
          </div>
          <div class="row">
            <div class="col left"><label>Complété :</label></div>
            <div class="col left">
              <RadioButton name="statutCompletee" value="COMPLETE" v-model="statutCompletee"/>
            </div>
          </div>
          <div class="row">
            <div class="col left"><label>Non complété :</label></div>
            <div class="col left">
              <RadioButton name="statutCompletee" value="NON_COMPLETE" v-model="statutCompletee"/>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-8">
      <div class="col">
        <div class="row">
          <div class="col-4 lbl"><label>Secteur assigné :</label></div>
          <div class="col-8">
            <Dropdown class="dropdown-height"
                      v-model="secteurAssigne"
                      :options="secteurAssigneLibelles"
                      optionValue="valeur"
                      optionLabel="texte"
                      scrollHeight="205px"
                      :showClear="true"
                      :disabled="!decisionsCriteres?.secteurAssigne?.ecritureAcces"
            />
          </div>
        </div>
      </div>
      <div class="col">
        <div class="row">
          <div class="col-4 lbl"><label>Intervenant :</label></div>
          <div class="col-8">
            <div v-if="intervenantsLoading == true" class="left">
              <vue-loaders name="ball-beat"></vue-loaders>
            </div>
            <div v-else>
              <Dropdown class="dropdown-height"
                        v-model="intervenant"
                        :options="intervenantLibelles"
                        optionValue="codeProfil"
                        optionLabel="description"
                        scrollHeight="205px"
                        :showClear="true"
                        :disabled="!decisionsCriteres?.intervenant?.ecritureAcces"
                        filter
                        filterPlaceholder="Rechercher..."
                        filterMatchMode="startsWith"
              />
            </div>
          </div>
        </div>
      </div>

      <div class="col">
        <div class="row">
          <div class="col-4 lbl"><label>Secteur d'origine :</label></div>
          <div class="col-8">
            <Dropdown class="dropdown-height"
                      v-model="secteurOrigine"
                      :options="secteurOrigineLibelles"
                      optionValue="valeur"
                      optionLabel="texte"
                      scrollHeight="205px"
                      :showClear="true"
                      :disabled="!decisionsCriteres?.secteurOrigine?.ecritureAcces"
            />
          </div>
        </div>
      </div>
      <div class="col pb5">
        <div class="row">
          <div class="col-4 lbl"><label>Demandeur :</label></div>
          <div class="col-8 left">
            <Dropdown class="dropdown-height"
                      v-model="demandeur"
                      :options="demandeurLibelles"
                      optionValue="codeProfil"
                      optionLabel="description"
                      scrollHeight="205px"
                      :showClear="true"
                      :disabled="!decisionsCriteres?.demandeur?.ecritureAcces"
            />
          </div>
        </div>
      </div>

      <div class="row"> <!--Date emis -->
        <div class="col">
          <div class="row">
            <div class="col-4 lbl">Émis du :</div>
            <div class="col">
              <CustomInputDate class="input-height input-width-100" type="date" max="9999-12-31" v-model="dateEmisDebut"/>
            </div>
          </div>
        </div>
        <div class="col">
          <div class="row">
            <div class="col-4 lbl">au :</div>
            <div class="col">
              <CustomInputDate class="input-height input-width-100" type="date" max="9999-12-31" v-model="dateEmisFin"/>
            </div>
          </div>

        </div>
      </div>

      <div class="row"> <!--Date prevu -->
        <div class="col">
          <div class="row">
            <div class="col-4 lbl">Prévu du :</div>
            <div class="col">
              <CustomInputDate class="input-height" type="date" max="9999-12-31" v-model="datePrevueDebut"/>
            </div>
          </div>
        </div>
        <div class="col">
          <div class="row">
            <div class="col-4 lbl">au :</div>
            <div class="col">
              <CustomInputDate class="input-height" type="date" max="9999-12-31" v-model="datePrevueFin"/>
            </div>
          </div>
        </div>
      </div>

      <div class="row"> <!--Date complete -->
        <div class="col">
          <div class="row">
            <div class="col-4 lbl">Complété entre le :</div>
            <div class="col">
              <CustomInputDate class="input-height" type="date" max="9999-12-31" v-model="dateCompleteeDebut"/>
            </div>
          </div>
        </div>
        <div class="col">
          <div class="row">
            <div class="col-4 lbl">et le :</div>
            <div class="col">
              <CustomInputDate class="input-height" type="date" max="9999-12-31" v-model="dateCompleteeFin"/>
            </div>
          </div>
        </div>
      </div>


      <div class="row">
        <div class="col">
          <div class="row">
            <div class="col-4 lbl"><label>Activité :</label></div>
            <div class="col-8 pl0">
              <Dropdown class="dropdown-height"
                        v-model="activite"
                        :options="activiteLibelles"
                        optionValue="valeur"
                        optionLabel="texte"
                        scrollHeight="205px"
                        :showClear="true"/>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row"> <!--Button-->
    <div class="col">
      <Button label="Rechercher" v-on:click="rechercher"/>
    </div>
    <div class="col">
      <Button label="Effacer critères" v-on:click="effacerCriteres"/>
    </div>
    <div class="col">
      <Button label="Fermer" v-on:click="fermer"/>
    </div>
  </div>
</template>

<script>

import {mapGetters} from 'vuex'
import axios from "axios";
import CustomInputDate from '../../Commun/CustomInputDate.vue'

export default {
  emits: ['rechercher', 'effacerCriteres', 'fermer'],
  props: ['criteresRecherche'],
  components: {
    CustomInputDate
  },
  created() {
    window.addEventListener('keydown', (e) => {
      if (e.key == 'Enter') {
        this.rechercher();
      }
    });
  },
  mounted() {

    axios.defaults.headers.common['cleProfil'] = this.profil.cle;
    this.$store.dispatch("dossier/obtenirSiteEntiteAction").then((res) => {
      this.setActivite(res.data.entite);
    });
    this.$store.dispatch('suivi/decisionsRechercheAction').then((res) => {
      this.decisionsCriteres = res.data;
      if (this.criteresRecherche) {
        this.initialisationCriteres = true;
        let criteres = ["demandeur", "intervenant", "entite", "secteurAssigne", "secteurOrigine", "siteOrigine",
          "activite", "dateEmisDebut", "datePrevueDebut", "dateCompleteeDebut", "dateEmisFin", "datePrevueFin",
          "dateCompleteeFin", "statutApprobation", "statutEmis", "statutCompletee"]
        criteres.forEach(critere => {
          if (this.criteresRecherche[critere]) {
            this[critere] = this.criteresRecherche[critere]
          }
        });
        this.dateEmisDebut = this.$commun.formatDate(this.criteresRecherche.dateEmisDebut);
        this.dateEmisFin = this.$commun.formatDate(this.criteresRecherche.dateEmisFin);
        this.datePrevueDebut = this.$commun.formatDate(this.criteresRecherche.datePrevueDebut);
        this.datePrevueFin = this.$commun.formatDate(this.criteresRecherche.datePrevueFin);
        this.dateCompleteeDebut = this.$commun.formatDate(this.criteresRecherche.dateCompleteeDebut);
        this.dateCompleteeFin = this.$commun.formatDate(this.criteresRecherche.dateCompleteeFin);
      }else {
        this.$store.dispatch('cardex/obtenirProfilInfoAction').then((res1) => {
          this.secteurAssigne = res1.data.secteur
        })
      }
    });
  },
  data() {
    return {
      intervenantsLoading: false,
      initialisationCriteres: false,
      critereRechercheSuivi: {},

      demandeur: null,
      intervenant: null,
      entite: null,
      secteurAssigne: null,
      secteurOrigine: null,
      siteOrigine: null,
      activite: null,
      dateEmisDebut: null,
      datePrevueDebut: null,
      dateCompleteeDebut: null,
      dateEmisFin: null,
      datePrevueFin: null,
      dateCompleteeFin: null,
      statutApprobation: 'APPROUVE_TOUS',
      statutEmis: 'EMIS_PAR_TOUS',
      statutCompletee: 'COMPLETE_TOUS',

      activiteLibelles: [],
      secteurAssigneLibelles: [],
      secteurOrigineLibelles: [],
      demandeurLibelles: [],
      intervenantLibelles: [],

      decisionsCriteres: {
        demandeur: null,
        entite: null,
        intervenant: null,
        secteurAssigne: null,
        secteurOrigine: null,
        siteOrigine: null
      }
    }
  },
  computed: {
    ...mapGetters({
      jeton: 'cardex/jeton',
      profil: 'cardex/profil',
    })
  },
  methods: {
    setActivite(entite) {
      this.$store.dispatch('dossier/onChangeEntityAction', {
        libelleChange: 'TypeActivite',
        nouvelleValeur: [entite]
      }).then((res) => {
        this.activiteLibelles = res.data;
      });
    },
    assignerListe(entiteDecision) {
      this.secteurAssigneLibelles = entiteDecision.secteurAssigne.libelles;
      this.secteurOrigineLibelles = entiteDecision.secteurOrigine.libelles;
    },
    rechercher() {
      this.critereRechercheSuivi.demandeur = this.demandeur;
      this.critereRechercheSuivi.intervenant = this.intervenant;
      this.critereRechercheSuivi.entite = this.entite;
      this.critereRechercheSuivi.secteurAssigne = this.secteurAssigne;
      this.critereRechercheSuivi.secteurOrigine = this.secteurOrigine;
      this.critereRechercheSuivi.siteOrigine = this.siteOrigine;
      this.critereRechercheSuivi.activite = this.activite;
      this.critereRechercheSuivi.statutApprobation = this.statutApprobation;
      this.critereRechercheSuivi.statutEmis = this.statutEmis;
      this.critereRechercheSuivi.statutCompletee = this.statutCompletee;
      if (this.dateEmisDebut !== null && this.dateEmisDebut !== undefined) {
        this.critereRechercheSuivi.dateEmisDebut= new Date(this.dateEmisDebut);
      }else {
        this.critereRechercheSuivi.dateEmisDebut = null;
      }
      if (this.datePrevueDebut !== null && this.datePrevueDebut !== undefined) {
        this.critereRechercheSuivi.datePrevueDebut= new Date(this.datePrevueDebut);
      } else {
        this.critereRechercheSuivi.datePrevueDebut = null;
      }
      if (this.dateCompleteeDebut !== null && this.dateCompleteeDebut !== undefined) {
        this.critereRechercheSuivi.dateCompleteeDebut= new Date(this.dateCompleteeDebut);
      } else {
        this.critereRechercheSuivi.dateCompleteeDebut = null;
      }
      if (this.dateEmisFin !== null && this.dateEmisFin !== undefined) {
        this.critereRechercheSuivi.dateEmisFin= new Date(this.dateEmisFin);
      } else {
        this.critereRechercheSuivi.dateEmisFin = null;
      }
      if (this.datePrevueFin !== null && this.datePrevueFin !== undefined) {
        this.critereRechercheSuivi.datePrevueFin= new Date(this.datePrevueFin);
      } else {
        this.critereRechercheSuivi.datePrevueFin = null;
      }
      if (this.dateCompleteeFin !== null && this.dateCompleteeFin !== undefined) {
        this.critereRechercheSuivi.dateCompleteeFin= new Date(this.dateCompleteeFin);
      } else {
        this.critereRechercheSuivi.dateCompleteeFin = null;
      }
      this.$emit("rechercher", this.critereRechercheSuivi);
    },
    effacerCriteres() {
      this.demandeur= null;
      this.intervenant= null;
      this.entite= null;
      this.secteurAssigne= null;
      this.secteurOrigine= null;
      this.siteOrigine= null;
      this.activite= null;
      this.dateEmisDebut= null;
      this.datePrevueDebut= null;
      this.dateCompleteeDebut= null;
      this.dateEmisFin= null;
      this.datePrevueFin= null;
      this.dateCompleteeFin= null;
      this.statutApprobation= 'APPROUVE_TOUS';
      this.statutEmis= 'EMIS_PAR_TOUS';
      this.statutCompletee= 'COMPLETE_TOUS';
      this.$emit("effacerCriteres");
    },
    fermer() {
      this.$store.commit('suivi/RESET_TOUT_SAUF_HISTORIQUE');
      this.$emit('fermer');
    }
  },
  watch: {
    secteurAssigne: function(val) {
      if(val !== null && val !== undefined){
        this.intervenantsLoading = true;
        this.$store.dispatch('suivi/obtenirListeIntervenantsSuiviAction', {
          secteur: val
        })
            .then((res) => {
              this.intervenantLibelles = res.data.sort(this.$commun.compareIntervenant);
              this.intervenantsLoading = false;
            });
      }else {
        this.intervenantLibelles = [];
        this.intervenant = null;
      }
    },
    secteurOrigine: function(val) {
      if(val !== null && val !== undefined){
        this.intervenantsLoading = true;
        this.$store.dispatch('suivi/obtenirListeIntervenantsSuiviAction', {
          secteur: val
        })
            .then((res) => {
              this.demandeurLibelles = res.data;
              this.intervenantsLoading = false;
            });
      }else {
        this.demandeurLibelles = [];
        this.demandeur = null;
      }
    }
  }
};
</script>